export default __webpack_public_path__ + "static/media/logo.3a93af86.jpg";